import { IOfferModeWithFSecure } from "@nju/data-access-portal-offers";
import { IHeaderMenuItemProps, IHeaderMenuLinksProps } from "../types";
import { HeaderMenuDesktopActiveAccount } from "./HeaderMenuDesktopActiveAccount";
import { HeaderMenuDesktopActiveItems } from "./HeaderMenuDesktopActiveItems";

interface IHeaderMenuDesktopActiveProps {
  items: IHeaderMenuItemProps[];
  links: IHeaderMenuLinksProps[];
  mode: IOfferModeWithFSecure;
}

export function HeaderMenuDesktopActive({
  items,
  links,
  mode,
}: IHeaderMenuDesktopActiveProps) {
  return (
    <>
      <HeaderMenuDesktopActiveItems items={items} />
      <HeaderMenuDesktopActiveAccount links={links} mode={mode} />
    </>
  );
}
